import React from 'react';

import { useTranslation } from 'react-i18next';

export const LoadingIndicator = () => {
  const { t } = useTranslation('pleri/chat');
  return <ShimmerText text={t('pleriIsThinking')} />;
};

export const ShimmerText = ({ text }: { text: string }) => (
  <span className="shimmer-text-anim block overflow-hidden text-sm font-normal tracking-wide whitespace-nowrap">
    {text}
  </span>
);

// Extracted reusable MorphingFluid component
export const MorphingFluid = ({
  size = 'h-4 w-4',
  containerColor = '#FF732E',
}: {
  size?: string;
  containerColor?: string;
}) => (
  <div className={`relative ${size}`}>
    {/* Morphing container */}
    <div
      className="animate-morph absolute inset-0 overflow-hidden"
      style={{
        borderRadius: '20%',
        background: containerColor, // Primary Orange by default
      }}
    >
      {/* Soft cloud-like fluid particles */}
      <div
        className="animate-cloud1 absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 40% 40%, rgba(255, 115, 46, 1) 0%, rgba(255, 115, 46, 0.7) 20%, rgba(255, 84, 0, 0.4) 40%, transparent 70%)',
          filter: 'blur(3px)',
          mixBlendMode: 'soft-light',
        }}
      />
      <div
        className="animate-cloud2 absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 60% 60%, rgba(255, 164, 27, 1) 0%, rgba(255, 140, 0, 0.6) 30%, rgba(255, 115, 46, 0.3) 50%, transparent 75%)',
          filter: 'blur(3px)',
          mixBlendMode: 'screen',
        }}
      />
      <div
        className="animate-cloud3 absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at 30% 70%, rgba(255, 183, 77, 0.9) 0%, rgba(255, 164, 27, 0.5) 40%, transparent 80%)',
          filter: 'blur(4px)',
          mixBlendMode: 'screen',
        }}
      />
      <div
        className="animate-cloud4 absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 70% 30%, rgba(248, 231, 125, 0.8) 0%, rgba(255, 183, 77, 0.4) 40%, transparent 70%)',
          filter: 'blur(3px)',
          mixBlendMode: 'overlay',
        }}
      />
      <div
        className="animate-cloud5 absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at 40% 30%, rgba(255, 84, 0, 0.9) 0%, rgba(255, 84, 0, 0.5) 30%, transparent 60%)',
          filter: 'blur(2px)',
          mixBlendMode: 'screen',
        }}
      />
      <div
        className="animate-cloud6 absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at 60% 70%, rgba(255, 164, 27, 0.8) 0%, rgba(255, 140, 0, 0.4) 40%, transparent 70%)',
          filter: 'blur(2px)',
          mixBlendMode: 'screen',
        }}
      />
    </div>
  </div>
);

export const StreamingIndicator = ({
  text = 'Writing response...',
}: {
  text?: string;
}) => (
  <div className="flex items-center gap-2">
    <MorphingFluid />
    <ShimmerText text={text} />
  </div>
);
